import { isSome, Maybe } from '@crocodille/util';
import {
  REQUIRED_VALIDATOR_V2,
  useForm,
  useFormField,
  useValidator,
  v2_useMinLengthValidator,
} from '../modules/forms';

export interface AccountPasswordFormData {
  readonly currentPassword: string;
  readonly newPassword: string;
  readonly confirmNewPassword: string;
}

export function useAccountPasswordForm(
  onSubmit: (data: AccountPasswordFormData) => void,
) {
  const currentPassword = useFormField({
    value: '',
    required: true,
    validators: [REQUIRED_VALIDATOR_V2],
  });

  const passwordMinLengthValidator = v2_useMinLengthValidator(5);

  const newPassword = useFormField({
    value: '',
    required: true,
    validators: [REQUIRED_VALIDATOR_V2, passwordMinLengthValidator],
  });

  const passwordConfirmationValidator = useValidator(
    (value: Maybe<string>) =>
      isSome(value) && value !== newPassword.value
        ? ('validation_error.password_confirmation' as const)
        : null,
    [newPassword.value],
  );

  const confirmNewPassword = useFormField({
    value: '',
    required: true,
    validators: [
      REQUIRED_VALIDATOR_V2,
      passwordMinLengthValidator,
      passwordConfirmationValidator,
    ],
  });

  return useForm({
    fields: {
      currentPassword,
      newPassword,
      confirmNewPassword,
    },
    onSubmit,
  });
}
